<div class="voltar">
  <div class="subdiv" (click)="voltar()">
    <arrow-back />
    <span>Voltar</span>
  </div>
</div>
